import splashTypes from "./splash.types";

const INITIAL_STATE={
    splash_data: {},
};

const splashReducer= (state= INITIAL_STATE, action) => {
    switch(action.type) {

        case splashTypes.SPLASH: {
            return {
                ...state,
                splash_data: action.payload
            }
        }
        default:
            return {...state}
    }
};


export default splashReducer;
